<template>
  <section
    class="article__header mb-1"
    :class="{
      'article__header--shadow': article.image_header.darken_image,
    }"
  >
    <div v-if="images.length > 0" class="article__header__img">
      <lazy-image :images="images" provider="sanity" preload force-show />
    </div>
    <div class="article__header__text container mt-2">
      <p v-if="hasDate" class="text-small text-md-base mb-0-4 mb-md-0-6">
        <i>
          {{
            $t('article.publicated_at', {
              date: $d(new Date(article.published_at), 'short'),
            })
          }}
        </i>
      </p>

      <div class="row-md justify-center">
        <div class="col-md-8">
          <p v-if="article.context_info" class="text w-600 mt-1-5 mb-1">
            {{ article.context_info }}
          </p>

          <h1 v-if="article.title" class="header-article__title jumbo mb-0">
            {{ article.title }}
          </h1>
        </div>
      </div>

      <!-- <portable-text
        v-if="article.hook.length > 0"
        :blocks="article.hook"
        class="article__header__abstract mt-0-6"
      /> -->

      <div
        v-if="next"
        class="article__header__button d-flex justify-center mt-2"
      >
        <div>
          <primary-button
            type="nuxt-link"
            :to="link"
            :href="link"
            :text="$t('article.next')"
            with-arrow
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LazyImage from '@/components/Image/LazyImage'
// import PrismicTitle from '@/components/Title/PrismicTitle'
// import RichText from '@/components/RichText/RichText'
import PrimaryButton from '@/components/buttons/Primary'
import { getSanityBunnyImageLink } from '@/utils/image'
// import PortableText from '@/components/RichText/PortableText.vue'

export default {
  name: 'ArticleHeader',
  components: {
    LazyImage,
    // PrismicTitle,
    // RichText,
    PrimaryButton,
    // PortableText,
  },
  props: {
    /** Article du component */
    article: {
      type: Object,
      required: true,
    },
    /** Le composant presente t-il le prochain article */
    next: {
      type: Boolean,
      default: false,
    },
  },
  head() {
    if (this.article.image_header.top_of_image_is_light) {
      return {
        htmlAttrs: {
          class: ['header--dark'],
        },
      }
    }
    return {}
  },
  computed: {
    link() {
      return this.$contextSanityPath(this.article)
    },
    hasDate() {
      return this.article.show_publish_date
    },
    images() {
      const imgs = []

      imgs.push({
        image: {
          url: getSanityBunnyImageLink(this.article.image_header.image, {
            width: 390,
            height: 470,
          }),
          dimensions: {
            width: 390,
            height: 470,
          },
        },
        widths: [320, 414, 640, 769],
        sizes: '100vw',
        media: {
          type: 'max',
          value: 768,
        },
        provider: 'sanity',
      })

      imgs.push({
        image: {
          url: getSanityBunnyImageLink(this.article.image_header.image, {
            width: 1440,
            height: 810,
          }),
          dimensions: {
            width: 1440,
            height: 810,
          },
        },
        sizes: '100vw',
        media: {
          type: 'min-max',
          value: 769,
          min: 769,
          max: 1444,
        },
        provider: 'sanity',
      })

      imgs.push({
        image: {
          url: getSanityBunnyImageLink(this.article.image_header.image, {
            width: 1920,
            height: 810,
          }),
          dimensions: {
            width: 1920,
            height: 810,
          },
        },
        sizes: '100vw',
        media: {
          type: 'min',
          value: 1445,
        },
        provider: 'sanity',
      })

      return imgs
    },
  },
}
</script>

<style lang="scss">
.article__header {
  position: relative;
  display: flex;
  flex-direction: column;

  &__text {
    width: 100%;
    text-align: center;
    padding-bottom: var(--spacing);
  }

  @include mq($from: tablet) {
    height: 100svh;
    min-height: #{rem(570px)};

    &__img {
      position: relative;
      width: 100%;
      flex-grow: 1;
      overflow: hidden;

      .lazy-image-container {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 50%;
        transform: translateY(-50%);
      }

      .lazy-image {
        padding-top: 0;
        height: 100%;

        img {
          width: auto;
          height: auto;
          min-width: 100%;
          min-height: 100%;
          max-width: none;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      &.image-focus--top {
        .lazy-image-container {
          top: 0;
          transform: translateY(0);
        }

        .lazy-image {
          img {
            top: 0;
            transform: translate(-50%, 0);
          }
        }
      }

      &.image-focus--bottom {
        .lazy-image-container {
          top: auto;
          bottom: 0;
          transform: translateY(0);
        }

        .lazy-image {
          img {
            top: auto;
            bottom: 0;
            transform: translate(-50%, 0);
          }
        }
      }
    }
  }

  &--old-image-height {
    height: auto;
    min-height: 0;

    .lazy-image-container {
      position: relative;
      top: auto;
      transform: translateY(0);
    }

    .lazy-image {
      padding-top: var(--padding-top, 100%);
    }
  }
}
</style>
